import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Sourcing from "@/pages/Sourcing";
import Prospection from "@/pages/Prospection";
import Dossiers from "@/pages/Dossiers";
import CompanyDetail from "@/pages/CompanyDetail";
import Pipeline from "@/pages/Pipeline";
import CRM from "@/pages/CRM";
import DataRoom from "@/pages/DataRoom";
import Reporting from "@/pages/Reporting";
import Campaigns from "@/pages/Campaigns";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import AeliamProspection from "@/pages/AeliamProspection";
import AeliamPipeline from "@/pages/AeliamPipeline";
import Contacts from "@/pages/Contacts";
import ApiKeys from "@/pages/ApiKeys";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-mono text-sm text-muted-foreground">Chargement…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Le rôle sales_aeliam atterrit sur l'espace Aeliam (pas le M&A).
function Home() {
  const { user } = useAuth();
  if (user?.role === "sales_aeliam") return <Navigate to="/aeliam" replace />;
  return <Dashboard />;
}

// Garde : un sales_aeliam ne peut pas accéder aux écrans M&A.
function NoSalesAeliam({ children }) {
  const { user } = useAuth();
  if (user?.role === "sales_aeliam") return <Navigate to="/aeliam" replace />;
  return children;
}

function SuperAdminOnly({ children }) {
  const { user } = useAuth();
  if (user?.role !== "super_admin") return <Navigate to="/" replace />;
  return children;
}

function SalesOrAdmin({ children }) {
  const { user } = useAuth();
  if (user?.role !== "super_admin" && user?.role !== "sales_aeliam") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Home />} />
              <Route path="/sourcing" element={<NoSalesAeliam><Sourcing /></NoSalesAeliam>} />
              <Route path="/prospection" element={<NoSalesAeliam><Prospection /></NoSalesAeliam>} />
              <Route path="/dossiers" element={<NoSalesAeliam><Dossiers /></NoSalesAeliam>} />
              <Route path="/cabinet/:id" element={<NoSalesAeliam><CompanyDetail /></NoSalesAeliam>} />
              <Route path="/pipeline" element={<NoSalesAeliam><Pipeline /></NoSalesAeliam>} />
              <Route path="/crm" element={<NoSalesAeliam><CRM /></NoSalesAeliam>} />
              <Route path="/campagnes" element={<NoSalesAeliam><Campaigns /></NoSalesAeliam>} />
              <Route path="/data-room" element={<NoSalesAeliam><DataRoom /></NoSalesAeliam>} />
              <Route path="/reporting" element={<NoSalesAeliam><Reporting /></NoSalesAeliam>} />
              <Route path="/aeliam" element={<AeliamProspection />} />
              <Route path="/aeliam/pipeline" element={<AeliamPipeline />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/cles-api" element={<SalesOrAdmin><ApiKeys /></SalesOrAdmin>} />
              <Route path="/parametres" element={<Settings />} />
              <Route path="/journal-audit" element={<AuditLog />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
